import fakeResponse from '../mock/fake-search';
import debounce from '../utils/debounce';

class Search {
  constructor(node) {
    this.node = node;
    this.search = document.querySelector('.js-search');
    this.input = document.querySelector('.js-search-input');
    this.loading = document.querySelector('.js-search-loading');
    this.hint = document.querySelector('.js-search-hint');
    this.results = document.querySelector('.js-search-results');

    this.state = {
      showResults: false
    };

    this.handleSearchButtonClick = this.handleSearchButtonClick.bind(this);
    this.handleSearchInput = this.handleSearchInput.bind(this);

    $(this.node).click(this.handleSearchButtonClick);
    $(this.input).change(this.handleSearchInput);
    $(this.input).on('input', debounce(this.handleSearchInput, 1000));
  }

  handleSearchButtonClick() {
    document.body.classList.toggle('body-fixed');
    document.body.classList.toggle('body--search-visible');
    this.node.classList.toggle('is-active');
    this.search.classList.toggle('visible');
    this.input.focus();

    $('.js-mobile-nav')[0].classList.remove('visible');
    $('.js-burger-button')[0].classList.remove('is-active');
  }

  renderResults(response) {
    if (!response.length) {
      return `
      <div class="middle center-xs marged-75 marged-top-75">
        Ничего не найдено по вашему запросу
      </div>
    `;
    }

    const $els = response.map(
      item => `
    <div class="search-page__item row with-delimeter marged-50 marged-25-xs">
      <div class="wrapper">
        <div class="row marged-50 marged-0-xs">
          <div
            class="search-page__item-content col-xs-24 ${
              item.description ? 'col-sm-14' : 'col-sm-24'
            }">
            <div class="search-sub with-color-blue marged-15">${
              item.label
            }</div>
            <div class="marged-20 marged-35-xs">
              <a class="large-news with-bold link link--blue with-arr-inline extra-xs" href="${
                item.link
              }">
                ${item.title}
              </a>
            </div>
            ${
              item.date
                ? `
              <div class="small-short with-color-light-blue with-bold">${
                item.date
              }</div>
            `
                : ''
            }
          </div>
          ${
            item.description
              ? `
            <div
              class="search-page__item-content col-xs-24 col-sm-8 col-sm-offset-2 marged-35-xs">
              <div class="small with-bold with-normal-xs with-color-blue marged-top-30 marged-top-15-xs">
                ${item.description}
              </div>
            </div>
          `
              : ''
          }
        </div>
      </div>
    </div>
  `
    );

    $(this.results).html($els.join(''));
  }

  toggleLoading(nextState) {
    if (!this.loading) return;
    this.loading.classList[nextState ? 'add' : 'remove']('visible');
  }

  toggleHint(nextState) {
    if (!this.hint) return;
    this.hint.classList[nextState ? 'add' : 'remove']('visible');
  }

  showResults(response) {
    const html = this.renderResults(response);
    $(this.results).html(html);

    this.state.showResults = true;
    this.toggleLoading(false);
    this.toggleHint(false);
    this.results.classList.add('visible');
  }

  hideResults() {
    this.state.showResults = false;
    this.toggleLoading(false);
    this.toggleHint(true);
    this.results.classList.remove('visible');
  }

  handleSearchInput(event) {
    const $input = event.target;

    const text = $($input).val();

    if (!text) {
      this.hideResults();
      return;
    }

    if (!window.ajaxUrl) {
      // FAKE REQUEST
      this.toggleLoading(true);

      setTimeout(() => {
        this.showResults(fakeResponse);
      }, 1000);
      return;
    }

    // 1. make request & get data
    // 2. render data,
    // 3. then visible
    /*
      [
        {
          "link": "http://avtoban.ru/page1/",
          "label": "Новости",
          "title": "Завершена государственная экспертиза оптимизированной проектной документации по инвестиционному проекту ЦКАД-4",
          "date": "12 марта 2019",
          "description": "Изменения коснулись некоторых транспортных развязок, количества протяженности водопропускных труб и количества мостовых 
      и искусственных сооружений. Обновленный проект включает более технологичную и долговечную конструкцию дорожной одежды."
        },{
        "link": "http://avtoban.ru/page2/",
          "label": "Инвесторам",
          "title": "В июне 2016 года «АВТОБАН-Финанс» впервые в истории Группы компаний «АВТОБАН» выпустил облигации на 3 млрд рублей. ",
        }
      ]
      */

    this.toggleLoading(true);

    fetch(window.ajaxUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'
      },
      credentials: 'same-origin',
      body: jQuery.param({
        action: 'search_ajax',
        search: text
      })
    })
      .then(response => {
        return response.json();
      })
      .then(response => {
        this.showResults(response);
      })
      .catch(err => {
        alert('Неизвестная ошибка!', err);
      });
  }
}

export default () => {
  const $searchButton = document.querySelector('.js-search-button');

  if (!$searchButton) {
    return;
  }

  window.search = new Search($searchButton);
};



// WEBPACK FOOTER //
// ./assets/scripts/components/search.js